"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateStaticPrefix = exports.generateMask = exports.generateEditableMask = exports["default"] = void 0;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations.validations;
  }
});
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.fill.js");
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.function.name.js");
var _formElements = require("@evidation/form-elements");
var _reactMaskedinput = _interopRequireDefault(require("react-maskedinput"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _lodash = _interopRequireDefault(require("lodash"));
var _validations = require("./validations");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Mask = (0, _styledComponents["default"])(_reactMaskedinput["default"]).withConfig({
  displayName: "maskCustom__Mask"
})(["font-size:", "rem;box-sizing:border-box;width:100%;padding:18px 14px;border:1px solid #e6e6e6;border-radius:3px;background:#fff;"], 14 / 16);
var LeftInlineLabel = _styledComponents["default"].label.withConfig({
  displayName: "maskCustom__LeftInlineLabel"
})(["padding:18px 10px;padding-left:0;color:rgba(64,64,64,1);opacity:0.8;"]);

// alphanumeric was renamed as length, but keeping both for backwards compatibility
var MASK_TYPES = ['alphanumeric', 'numeric', 'length'];
var MASK_PATTERNS = {
  alphanumeric: '*',
  alphanumericUpcase: '#',
  digit: '1',
  letter: 'a',
  letterUpcase: 'A'
};
var generateStaticPrefix = exports.generateStaticPrefix = function generateStaticPrefix() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return _lodash["default"].map(prefix, function (_char) {
    return "\\".concat(_char);
  }).join('');
};
var generateEditableMask = exports.generateEditableMask = function generateEditableMask(_ref) {
  var mask_custom_type = _ref.mask_custom_type,
    mask_custom_restrict_input = _ref.mask_custom_restrict_input,
    mask_custom_max = _ref.mask_custom_max;
  switch (mask_custom_type) {
    case 'alphanumeric': // for backwards compatibility
    case 'length':
      switch (mask_custom_restrict_input) {
        case 'numeric':
          return new Array(mask_custom_max).fill(MASK_PATTERNS.digit).join('');
        case 'letter':
          return new Array(mask_custom_max).fill(MASK_PATTERNS.letter).join('');
        case 'alphanumeric':
        default:
          return new Array(mask_custom_max).fill(MASK_PATTERNS.alphanumeric).join('');
      }
    case "numeric":
      return new Array(mask_custom_max.toString().length).fill(MASK_PATTERNS.digit).join('');
    default:
      return '';
  }
};
var generateMask = exports.generateMask = function generateMask(_ref2) {
  var mask_custom_max = _ref2.mask_custom_max,
    mask_custom_type = _ref2.mask_custom_type,
    mask_custom_restrict_input = _ref2.mask_custom_restrict_input,
    prefix = _ref2.prefix;
  var staticPrefix = generateStaticPrefix(prefix);
  var editableMask = generateEditableMask({
    mask_custom_type: mask_custom_type,
    mask_custom_max: mask_custom_max,
    mask_custom_restrict_input: mask_custom_restrict_input
  });
  return staticPrefix + editableMask;
};
var MaskCustom = /*#__PURE__*/function (_React$Component) {
  function MaskCustom() {
    var _this;
    (0, _classCallCheck2["default"])(this, MaskCustom);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MaskCustom, [].concat(args));
    (0, _defineProperty2["default"])(_this, "onChange", function (e) {
      _this.props.input.onChange(e.target.value.trim());
    });
    (0, _defineProperty2["default"])(_this, "onBlur", function (e) {
      _this.props.input.onBlur(e.target.value.trim());
    });
    return _this;
  }
  (0, _inherits2["default"])(MaskCustom, _React$Component);
  return (0, _createClass2["default"])(MaskCustom, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$input = _this$props.input,
        onFocus = _this$props$input.onFocus,
        name = _this$props$input.name,
        value = _this$props$input.value,
        _this$props$meta = _this$props.meta,
        error = _this$props$meta.error,
        touched = _this$props$meta.touched,
        inputStyle = _this$props.inputStyle,
        label = _this$props.label,
        smallLabel = _this$props.smallLabel,
        labelStyle = _this$props.labelStyle,
        left_inline_label = _this$props.left_inline_label,
        required = _this$props.required,
        default_select_value = _this$props.default_select_value,
        disabled = _this$props.disabled;
      return /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        required: required,
        label: label || smallLabel,
        labelStyle: labelStyle || inputStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex'
        }
      }, left_inline_label && /*#__PURE__*/_react["default"].createElement(LeftInlineLabel, null, left_inline_label), /*#__PURE__*/_react["default"].createElement(Mask, {
        name: name,
        value: value,
        onChange: this.onChange,
        onFocus: onFocus,
        onBlur: this.onBlur,
        id: name,
        mask: generateMask(this.props),
        placeholderChar: ' ',
        placeholder: default_select_value,
        disabled: disabled
      })));
    }
  }]);
}(_react["default"].Component);
MaskCustom.defaultProps = {
  mask_custom_type: "length",
  mask_custom_min: 1,
  mask_custom_max: 1,
  inputStyle: "achievement",
  labelStyle: "dark"
};
MaskCustom.propTypes = {
  mask_custom_type: _propTypes["default"].oneOf(MASK_TYPES).isRequired,
  mask_custom_min: _propTypes["default"].number.isRequired,
  mask_custom_max: _propTypes["default"].number.isRequired,
  mask_custom_restrict_input: _propTypes["default"].string,
  label: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  error: _propTypes["default"].string,
  prefix: _propTypes["default"].string
};
var _default = exports["default"] = MaskCustom;